import React from "react";
import { Router } from "@reach/router";
import {
  UserDetection,
  ProfileSelection,
  Products,
  Summary
} from "../screens/index";

const Navigation = () => (
  <Router>
    <Summary path="/summary" />
    <Products path="/products" />
    <ProfileSelection path="/profiles" />
    <UserDetection path="/" />
  </Router>
);

export default Navigation;
